import "../App.css";
import "../general.css";
import "../queries.css";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import z from "zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";
import config from "../config";
import { toast } from "react-hot-toast";
import InfoPopup from "../components/InfoPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import Seo from "../components/SEO"
import { useFacebookPageView } from "../hook/useFacebookPageView";

const formSchema = z.object({
  name: z
    .string({ required_error: "Name is required" })
    .min(3, "Name must be at least 3 character."),
  companyName: z
    .string({ required_error: "Name is required" })
    .min(3, "Name must be at least 3 character."),
  companyType: z.string({ required_error: "Company Type is required" }),
  phone: z.string().nullish(),
  email: z.string({ required_error: "Email is required" }).email(),
  message: z.string({ required_error: "Message is required" }),
});

type FormType = z.infer<typeof formSchema>;

function Partner() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/partner", title: "Become a reseller page" });
  }, []);

  useFacebookPageView();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormType>({
    resolver: zodResolver(formSchema),
  });

  const onSubmit: SubmitHandler<FormType> = (data) => {
    axios
      .post(`${config.HOST}/insert_user.php`, {...data, page: 'partner'}, {headers: {
        'content-type': 'multipart/form-data'
      }})
      .then(() => {
        toast.success('Successfully submitted.')
      })
      .catch(() => {
        toast.error("Failed to send.");
      });
  };

  useEffect(() => {
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);

  const [infoVisible, setInfoVisible] = useState(false);

  const toggleInfo = () => {
    setInfoVisible(!infoVisible);
  };

  return (
    <motion.main
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >


    <Seo
      title="Spread the feeling"
      description="More info for potential resellers and distributors"
      url="https://therouseco.com/partner"
      keywords={["Rouse, drink, rehydration, sex, F*** It, distributors, resellers, sell, shop, "]}
      uploadDate="2025-07-09"
      includeVideoSchema={false}
    />

      <section className="section-form" id="partner" style={{ paddingTop: "30px" }}>
        <div className="form-div">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              className="heading-primary subheading"
              style={{ padding: "60px 0px", width: "100%" }}
            >
              DISTRIBUTION & RESALE{" "}
              <div style={{ display: "flex" }}>
                <FontAwesomeIcon
                  style={{
                    display: windowWidth < 600 ? "flex" : "none",
                    marginTop: "10px",
                    marginLeft: "auto",
                  }}
                  onClick={toggleInfo}
                  icon={faInfoCircle}
                />
              </div>
            </div>
            <InfoPopup
              visible={infoVisible}
              info={
                <>
                  {" "}
                  <p className="">
                    Yeah, we get it — Rouse looks like something you'd want on your shelf.  
                    And you're not wrong.  
                    But the good stuff takes a minute.
                    </p>

                    <p>
                    We're live on Indiegogo — orders are rolling in,  
                    shipping starts in 3–5 months.
                    </p>

                    <p>
                    Drop your details below to be part of our first-order club:  
                    early access, lifetime best distributor price perks, and a front-row seat to launch.
                    </p>
                </>
              }
              onClose={() => {
                setInfoVisible(false);
              }}
            />
            <div className="input-group">
              YOUR NAME*
              <input type="text" {...register("name")}></input>
              {errors.name && <p> {errors.name?.message}</p>}
            </div>
            <div className="input-group">
              COMPANY NAME*
              <input type="text" {...register("companyName")}></input>
              {errors.companyName && <p> {errors.companyName?.message}</p>}
            </div>
            <div className="input-group">
              PHONE NUMBER
              <input type="phone" {...register("phone")}></input>
              {errors.phone && <p> {errors.phone?.message}</p>}
            </div>
            <div className="input-group">
              EMAIL ADDRESS*
              <input type="email" {...register("email")}></input>
              {errors.email && <p> {errors.email?.message}</p>}
            </div>
            <div className="input-group">
              COMPANY TYPE*
              <select {...register("companyType")}>
              <option value="onlineShop">Online shop</option>
              <option value="physicalRetailStore">Physical retail store</option>
              <option value="storeNetwork">Store network</option>
              <option value="importerOrWholesaleDistributor">Importer / Wholesale distributor</option>
              <option value="club">Club</option>
              <option value="other">Other</option>
              </select>
              {errors.companyType && <p> {errors.companyType?.message}</p>}
            </div>
            <div className="input-group">
              MESSAGE
              <textarea
                className="multiline"
                style={{ minHeight: "100px" }}
                {...register("message")}
              ></textarea>
              {errors.email && <p> {errors.email?.message}</p>}
            </div>
            <input
              type="submit"
              style={{ marginTop: "70px" }}
              value="Submit"
            ></input>
          </form>
          <div
            className="form-text info-text small-text"
            style={{ color: "white" }}
          >
            <div
              className="heading-primary subheading drawn"
              style={{
                padding: "60px 40px",
                color: "white",
                marginTop: "20px",
              }}
            >
              Spread the Feels
            </div>
            <p className="">
              Yeah, we get it — Rouse looks like something you'd want on your shelf.  
              And you're not wrong.  
              But the good stuff takes a minute.
              </p>

              <p>
              We're live on Indiegogo — orders are rolling in,  
              shipping starts in 3–5 months.
              </p>

              <p>
              Drop your details below to be part of our first-order club:  
              early access, lifetime best distributor price perks, and a front-row seat to launch.
              </p>
          </div>
        </div>
      </section>
    </motion.main>
  );
}

export default Partner;
